<!-- 下拉选择器 -->
<template>
    <div class="content">
        <select v-model="selectedValue" class="select-box" @change="changeDate">
            <option disabled value="">请选择</option>
            <option v-for="(option, index) in selectOption" :key="index" :value="option.value">{{ option.label }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        selectOption: Array,
        defaultValue: String
    },
    data() {
        return {
            selectedValue: null
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedValue = this.defaultValue;
        });
    },
    methods: {
        changeDate() {
            this.$emit('handleChange', this.selectedValue);
        }
    }
};
</script>

<style lang="less" scoped>
.content {
    width: 100%;
}
.select-box {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 30px;
    padding: 5px;
    font-size: 12px;
    border: none;
    outline: none;
    appearance: none;
    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Safari 和 Chrome */
    cursor: pointer;
}
</style>